module.exports = __webpack_public_path__ + "img/question.0c432fa7.svg";